import { IHoliday } from "../holidayTypes";

export const SwitzerlandHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2024-01-02": { title: "Berchtoldstag", type: "SPECIAL_DAY" }, // Firad i vissa kantoner
  "2024-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" }, // Firad i vissa kantoner
  "2024-03-19": { title: "Josefstag", type: "SPECIAL_DAY" }, // Firad i vissa katolska kantoner
  "2024-03-29": { title: "Karfreitag", type: "HOLIDAY" },
  "2024-04-01": { title: "Ostermontag", type: "HOLIDAY" },
  "2024-05-01": { title: "Tag der Arbeit", type: "SPECIAL_DAY" }, // Firad i vissa kantoner
  "2024-05-09": { title: "Auffahrt", type: "HOLIDAY" },
  "2024-05-20": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2024-05-30": { title: "Fronleichnam", type: "SPECIAL_DAY" }, // Firad i katolska kantoner
  "2024-08-01": { title: "Bundesfeier", type: "HOLIDAY" }, // Schweiz nationella helgdag
  "2024-08-15": { title: "Mariä Himmelfahrt", type: "SPECIAL_DAY" }, // Firad i katolska kantoner
  "2024-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" }, // Firad i katolska kantoner
  "2024-12-08": { title: "Mariä Empfängnis", type: "SPECIAL_DAY" }, // Firad i katolska kantoner
  "2024-12-25": { title: "Weihnachtstag", type: "HOLIDAY" },
  "2024-12-26": { title: "Stephanstag", type: "HOLIDAY" },

  // 2025
  "2025-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2025-01-02": { title: "Berchtoldstag", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-03-19": { title: "Josefstag", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-04-18": { title: "Karfreitag", type: "HOLIDAY" },
  "2025-04-21": { title: "Ostermontag", type: "HOLIDAY" },
  "2025-05-01": { title: "Tag der Arbeit", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-05-29": { title: "Auffahrt", type: "HOLIDAY" },
  "2025-06-09": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2025-06-19": { title: "Fronleichnam", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-08-01": { title: "Bundesfeier", type: "HOLIDAY" },
  "2025-08-15": { title: "Mariä Himmelfahrt", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-12-08": { title: "Mariä Empfängnis", type: "SPECIAL_DAY" }, // Endast i vissa kantoner
  "2025-12-24": { title: "Heiligabend", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Weihnachtstag", type: "HOLIDAY" },
  "2025-12-26": { title: "Stephanstag", type: "HOLIDAY" },
  "2025-12-31": { title: "Silvester", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2026-01-02": { title: "Berchtoldstag", type: "SPECIAL_DAY" },
  "2026-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" },
  "2026-03-19": { title: "Josefstag", type: "SPECIAL_DAY" },
  "2026-04-03": { title: "Karfreitag", type: "HOLIDAY" },
  "2026-04-06": { title: "Ostermontag", type: "HOLIDAY" },
  "2026-05-01": { title: "Tag der Arbeit", type: "SPECIAL_DAY" },
  "2026-05-14": { title: "Auffahrt", type: "HOLIDAY" },
  "2026-05-25": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2026-06-04": { title: "Fronleichnam", type: "SPECIAL_DAY" },
  "2026-08-01": { title: "Bundesfeier", type: "HOLIDAY" },
  "2026-08-15": { title: "Mariä Himmelfahrt", type: "SPECIAL_DAY" },
  "2026-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" },
  "2026-12-08": { title: "Mariä Empfängnis", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Weihnachtstag", type: "HOLIDAY" },
  "2026-12-26": { title: "Stephanstag", type: "HOLIDAY" },
  "2026-12-31": { title: "Silvester", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2027-01-02": { title: "Berchtoldstag", type: "SPECIAL_DAY" },
  "2027-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" },
  "2027-03-19": { title: "Josefstag", type: "SPECIAL_DAY" },
  "2027-03-26": { title: "Karfreitag", type: "HOLIDAY" },
  "2027-03-29": { title: "Ostermontag", type: "HOLIDAY" },
  "2027-05-01": { title: "Tag der Arbeit", type: "SPECIAL_DAY" },
  "2027-05-06": { title: "Auffahrt", type: "HOLIDAY" },
  "2027-05-17": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2027-05-27": { title: "Fronleichnam", type: "SPECIAL_DAY" },
  "2027-08-01": { title: "Bundesfeier", type: "HOLIDAY" },
  "2027-08-15": { title: "Mariä Himmelfahrt", type: "SPECIAL_DAY" },
  "2027-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" },
  "2027-12-08": { title: "Mariä Empfängnis", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Weihnachtstag", type: "HOLIDAY" },
  "2027-12-26": { title: "Stephanstag", type: "HOLIDAY" },
  "2027-12-31": { title: "Silvester", type: "SPECIAL_DAY" }
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/switzerlandHolidays.ts